<app-thi-page-shell [lang]="landingLang">
<div class="page-wrapper pt-20">
    <div class="container-fluid p-0">
      <div class="row">
        <div class="col-12">     
          <div class="login-card">
            <div>
              <div>
                <!-- <a class="logo" routerLink='/'>
                  <img class="img-fluid for-light" src="assets/images/logo/login.png" alt="looginpage">
                  <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="looginpage">
                </a> -->
              </div>
              <div class="login-main"> 
                <form class="theme-form" [formGroup]="ForgetPassword">
                  <h4  style=" color: #141414; text-align: center; " > {{'forget.reset'|translate}}</h4>
           
                  <div class="text-center mt-4 mb-4"><span class="reset-password-link"> {{'forget.if'|translate}}  <a class="btn-link text-danger" routerLink='/resend-otp'> {{'forget.resend'|translate}} </a></span></div>
                
                  <div class="form-group">
                    <label class="col-form-label" style=" color: #141414;"> {{'forget.otp'|translate}}</label>
                    <input class="form-control" type="number"  required=""  formControlName="otp">
                    <div *ngIf="ForgetPassword.get('otp')?.errors != null && ForgetPassword.get('otp')?.touched" class=" alert text-danger ">
                      <p  *ngIf="ForgetPassword.get('otp')?.errors?.required" class=" text-danger"> {{'forget.otpreq'|translate}}</p>
                     </div>
                  </div>

                  <div class="form-group">
                    <label class="col-form-label" style="color: #141414;">
                      {{ userLanguage === 'ar' ? 'كود الأمان' : (userLanguage === 'he' ? 'קוד אבטחה' : 'Security Code') }}
                    </label>
                    <input class="form-control" type="text" required="" formControlName="security_code"
                      placeholder="{{ userLanguage === 'ar' ? 'ادخل كود الأمان' : (userLanguage === 'he' ? 'הזן קוד אבטחה' : 'Enter security code') }}"
                      maxlength="10" style="letter-spacing: 3px; text-transform: uppercase;">
                    <div *ngIf="ForgetPassword.get('security_code')?.errors != null && ForgetPassword.get('security_code')?.touched" class="alert text-danger">
                      <p *ngIf="ForgetPassword.get('security_code')?.errors?.required" class="text-danger">
                        {{ userLanguage === 'ar' ? 'كود الأمان مطلوب' : (userLanguage === 'he' ? 'קוד אבטחה נדרש' : 'Security code is required') }}
                      </p>
                    </div>
                    <small class="text-muted" style="font-size: 11px;">
                      {{ userLanguage === 'ar' ? 'تواصل مع المسؤول للحصول على كود الأمان' : (userLanguage === 'he' ? 'פנה למנהל כדי לקבל את קוד האבטחה' : 'Contact your admin to get the security code') }}
                    </small>
                  </div>

                  <div class="form-group">
                    <label class="col-form-label" style="color: #141414;">{{'Register.password'|translate}}</label>
                    <!-- Input + eye icon wrapper -->
                    <div class="position-relative">
                      <input class="form-control" [type]="show ? 'text' : 'password'" name="login[password]" required="" placeholder="*********"
                        formControlName="password">
                      <div class="show-hide" [ngClass]="{'rtl': userLanguage === 'ar' || userLanguage === 'he'}" (click)="showPassword()">
                        <i class="fa" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"></i>
                      </div>
                    </div>
                    <!-- Error messages -->
                    <div *ngIf="ForgetPassword.get('password')?.errors && ForgetPassword.get('password')?.touched" class="alert text-danger my-1">
                      <p *ngIf="ForgetPassword.get('password')?.errors?.required" class="text-danger">{{'Register.passwordRequierd'|translate}}</p>
                      <p *ngIf="ForgetPassword.get('password')?.errors?.minlength" class="my-1 text-danger">{{'Login.passwordMinLength'|translate}}</p>
                      <p *ngIf="ForgetPassword.get('password')?.errors?.maxlength" class="my-1 text-danger">{{'Login.passwordMaxLength'|translate}}</p>
                      <p *ngIf="ForgetPassword.get('password')?.errors?.uppercase" class="my-1 text-danger">{{'Login.passwordUppercase'|translate}}</p>
                      <p *ngIf="ForgetPassword.get('password')?.errors?.specialChar" class="my-1 text-danger">{{'Login.passwordSpecialChar'|translate}}</p>
                    </div>
                    <!-- Password Requirements Checklist -->
                    <div class="pw-requirements" *ngIf="ForgetPassword.get('password')?.value || ForgetPassword.get('password')?.touched">
                      <div class="pw-req-title">
                        {{ userLanguage === 'en' ? 'Password requirements:' : (userLanguage === 'ar' ? 'متطلبات كلمة المرور:' : 'דרישות סיסמה:') }}
                      </div>
                      <div class="pw-req-item" [class.met]="passwordChecks.uppercase">
                        <i class="fa" [class.fa-check-circle]="passwordChecks.uppercase" [class.fa-circle-o]="!passwordChecks.uppercase"></i>
                        {{ userLanguage === 'en' ? 'At least one uppercase letter (A-Z)' : (userLanguage === 'ar' ? 'على الأقل حرف واحد بأحرف كبيرة (A-Z)' : 'אות גדולה אחת לפחות (A-Z)') }}
                      </div>
                      <div class="pw-req-item" [class.met]="passwordChecks.lowercase">
                        <i class="fa" [class.fa-check-circle]="passwordChecks.lowercase" [class.fa-circle-o]="!passwordChecks.lowercase"></i>
                        {{ userLanguage === 'en' ? 'At least one lowercase letter (a-z)' : (userLanguage === 'ar' ? 'على الأقل حرف واحد بأحرف صغيرة (a-z)' : 'אות קטנה אחת לפחות (a-z)') }}
                      </div>
                      <div class="pw-req-item" [class.met]="passwordChecks.number">
                        <i class="fa" [class.fa-check-circle]="passwordChecks.number" [class.fa-circle-o]="!passwordChecks.number"></i>
                        {{ userLanguage === 'en' ? 'At least one number (0-9)' : (userLanguage === 'ar' ? 'على الأقل رقم واحد (0-9)' : 'ספרה אחת לפחות (0-9)') }}
                      </div>
                      <div class="pw-req-item" [class.met]="passwordChecks.specialChar">
                        <i class="fa" [class.fa-check-circle]="passwordChecks.specialChar" [class.fa-circle-o]="!passwordChecks.specialChar"></i>
                        {{ userLanguage === 'en' ? 'At least one special character (!@#$%^&*)' : (userLanguage === 'ar' ? 'على الأقل رمز خاص واحد (!@#$%^&*)' : 'תו מיוחד אחד לפחות (!@#$%^&*)') }}
                      </div>
                      <div class="pw-req-item" [class.met]="passwordChecks.minLength">
                        <i class="fa" [class.fa-check-circle]="passwordChecks.minLength" [class.fa-circle-o]="!passwordChecks.minLength"></i>
                        {{ userLanguage === 'en' ? 'Minimum 8 characters' : (userLanguage === 'ar' ? 'بحد الأدنى 8 أحرف' : 'לפחות 8 תווים') }}
                      </div>
                    </div>
                  </div>
                 
                 
                  <p class="mt-4 mb-0"> {{'forget.Already'|translate}} <a class="ms-2" [routerLink]="'/login'" style=" color: #141414;"> {{'Login.login'|translate}}</a></p>
                  <button class="btn d-block w-100"
                   style="background-color: #141414; color: #fff;" 
                   type="submit" (click)="submitForget(ForgetPassword)"
                   [disabled]="!ForgetPassword.valid"> {{'forget.submit'|translate}}</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-thi-page-shell>